import { useMutation } from '@tanstack/react-query'
import { trpc } from '~/lib/trpc'

export function useCreateUserInvitation() {
  return useMutation(trpc.users.createUserInvitation.mutationOptions())
}
